package calculator

data class CalculationAssumption(
    val key: String,
    val label: String,
    val valueDescription: String,
    val sourceLabel: String,
    val lastUpdated: String,
    val confidence: String,
)

val defaultCalculationAssumptions = listOf(
    CalculationAssumption("noEVisaPeriodDays", "Период штампа", "45 дней по умолчанию", "Настраиваемое предположение пользователя", "2026-05-27", "medium"),
    CalculationAssumption("eVisaPeriodDays", "Период e-Visa", "90 дней по умолчанию", "Настраиваемое предположение пользователя", "2026-05-27", "medium"),
    CalculationAssumption("apecPeriodDays", "Период АТЭС", "60 дней по умолчанию", "Настраиваемое предположение пользователя", "2026-05-27", "medium"),
    CalculationAssumption("apecCardCostRub", "Стоимость карты АТЭС", "75 000 RUB по умолчанию", "Партнерская/рыночная цена, задается владельцем", "2026-05-27", "medium"),
)

data class CalculationPreset(
    val id: String,
    val title: String,
    val description: String,
    val input: CalculatorInput,
)

val defaultCalculationPresets = listOf(
    CalculationPreset("remote-worker", "Удаленный специалист", "Базовый сценарий с одним потерянным рабочим днем на выезд.", CalculatorInput()),
    CalculationPreset("frequent-traveler", "Частые поездки по АТЭС", "Учитывает выгоду fast-track и поездок по странам АТЭС.", CalculatorInput(fastTrackCrossingsPerYear = 12.0, fastTrackMinutesSavedPerCrossing = 30.0, apecOtherTravelSavingsRub = 30_000.0)),
    CalculationPreset("high-income", "Высокая стоимость времени", "Показывает, как растет цена визаранов при дорогом рабочем дне.", CalculatorInput(monthlyIncomeRub = 700_000.0, taxAndOpportunityCostFactor = 1.5)),
)
